import React, { useState } from 'react';

const AddCommentForm = ({ onAddComment }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [text, setText] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name || !email || !text) return;
    onAddComment(name, email, text);
    setName('');
    setEmail('');
    setText('');
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <h4 className="font-serif text-xl font-semibold text-stone-900">Post a Comment</h4>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <input
          type="text"
          placeholder="Your Name (Required)"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="field"
          required
        />
        <input
          type="email"
          placeholder="Email Address (Required)"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="field"
          required
        />
      </div>
      <textarea
        placeholder="Your Comment..."
        value={text}
        onChange={(e) => setText(e.target.value)}
        rows="4"
        className="field"
        required
      />
      <button
        type="submit"
        className="px-5 py-2.5 bg-stone-900 text-white text-sm font-medium rounded-full hover:bg-stone-800 transition"
      >
        Submit Comment
      </button>
    </form>
  );
};

export default AddCommentForm;
